import { render, staticRenderFns } from "./LaundryItem.vue?vue&type=template&id=78a930b2&scoped=true"
import script from "./LaundryItem.vue?vue&type=script&lang=js"
export * from "./LaundryItem.vue?vue&type=script&lang=js"
import style0 from "./LaundryItem.vue?vue&type=style&index=0&id=78a930b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a930b2",
  null
  
)

export default component.exports